import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import districtApi from 'api/districtApi'

export const thunkDistrict = createAsyncThunk(
  'district/getAll',
  async (param, thunkApi) => {
    try {
      const res = await districtApi.getAll(param)
      return res // Trả về dữ liệu API trả về
    } catch (error) {
      return thunkApi.rejectWithValue(error) // Xử lý lỗi
    }
  },
)
const reportSlice = createSlice({
  name: 'district',
  initialState: {
    processes: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(thunkDistrict.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(thunkDistrict.fulfilled, (state, action) => {
        state.loading = false
        state.processes = action.payload // Cập nhật state với dữ liệu trả về
      })
  },
})

const { reducer } = reportSlice
export default reducer
